export interface RewindEntry {
  id: number;
  przewinieta: boolean;
  marked_to_rewind?: boolean;
}

/**
 * Whether the "Do przewijania" action may be offered for a position.
 *
 * - an unmarked pending entry (sent to the station automatically) still waits for the
 *   operator's mark, so marking is allowed;
 * - a marked pending entry means it is already waiting — nothing to do;
 * - an already rewound position must not be sent again (the backend refuses it too);
 *   an admin restores it at the rewinding station instead. An unmarked pending entry next
 *   to a rewound one is a leftover of the old re-add bug, not a reason to offer the action.
 */
export const canMarkToRewind = (entries: RewindEntry[] | null | undefined): boolean => {
  const list = Array.isArray(entries) ? entries : [];
  if (list.some((e) => e.przewinieta)) return false;
  if (list.some((e) => !e.przewinieta && !e.marked_to_rewind)) return true;
  return !list.some((e) => !e.przewinieta && e.marked_to_rewind) && !list.some((e) => e.przewinieta);
};

/**
 * Whether the produced quantity may no longer be changed: the position has been rewound and
 * nothing is waiting at the station (the backend refuses the change too). An admin unlocks it
 * by restoring the entry at the rewinding station.
 */
export const isQuantityLockedByRewind = (entries: RewindEntry[] | null | undefined): boolean => {
  const list = Array.isArray(entries) ? entries : [];
  return list.some((e) => e.przewinieta) && !list.some((e) => !e.przewinieta);
};
